// @ts-nocheck

import _isEmpty from 'lodash/isEmpty';
import CommonApi from './../commonApi';
import { fetchRequest } from '.';
import { convertFromMToKm, convertFromKmToM } from '../pure/unitConversions';
type SelfRegulationVehicle = {
  kilometrage: number;
  yearKilometrage: number;
  [key: string]: unknown;
};

type SelfRegulationData = {
  orgUnits?: Record<string, number>;
  selfVehicleRegulationVehicles?: SelfRegulationVehicle[];
};

const convertDataFromServer = (value: SelfRegulationData) => {
  if (value.orgUnits && !_isEmpty(value.orgUnits)) {
    value.orgUnits = Object.entries(value.orgUnits).reduce((acc, [key, value]) => ({
      ...acc,
      [key]: convertFromMToKm(value)
    }), {});
  }
  if (value.selfVehicleRegulationVehicles?.length) {
    value.selfVehicleRegulationVehicles = value.selfVehicleRegulationVehicles.map(v => ({
      ...v,
      kilometrage: convertFromMToKm(v.kilometrage) ?? 0,
      yearKilometrage: convertFromMToKm(v.yearKilometrage) ?? 0
    }));
  }
  return value;
};
const convertDataToServer = (value: SelfRegulationData) => {
  if (value.orgUnits && !_isEmpty(value.orgUnits)) {
    value.orgUnits = Object.entries(value.orgUnits).reduce((acc, [key, value]) => ({
      ...acc,
      [key]: convertFromKmToM(value)
    }), {});
  }
  if (value.selfVehicleRegulationVehicles?.length) {
    value.selfVehicleRegulationVehicles = value.selfVehicleRegulationVehicles.map(v => ({
      ...v,
      kilometrage: convertFromKmToM(v.kilometrage) ?? 0,
      yearKilometrage: convertFromKmToM(v.yearKilometrage) ?? 0
    }));
  }
  return value;
};
const selfVehicleRegulations = Object.assign(
  new CommonApi<SelfRegulationData>(
    'selfVehicleRegulation',
    'бюджет',
    convertDataToServer,
    convertDataFromServer
  ),
  {
    changeStatus: async (id: number, status: unknown) =>
      await fetchRequest.put(`/selfVehicleRegulation/changeStatus`, {
        id,
        status
      })
  }
);
export default selfVehicleRegulations;
